import React, { useEffect, useState } from "react";
import axios from 'axios';
import { useAuth } from "../context/auth";
import { Link } from "react-router-dom";
import StoreNewWA from "../component/Homecomponent/StoreNewWA";
import HomeBanner from "../component/Homecomponent/HomeBanner";
import CelebrityScroll from "../component/Homecomponent/CelebrityScroll";
import LayoutWithoutFooter from "../component/Layout/LayoutWithoutFooter";
import WomenOfChaashniWP from "../component/Homecomponent/WomenOfChaashniWP";
import AboutChaashniWA from "../component/Homecomponent/AboutChaashniWA";
import CoutureWA from "../component/Homecomponent/CoutureWA";
import VideoGalleryWA from "../component/Homecomponent/VideoGalleryWA";
import InstagramWA from "../component/Homecomponent/InstagramWA";
export default function HomePageWhatsAppInsta() {
  const [lauth, setLauth] = useAuth();
  const [validated, setValidated] = useState(false);
  const [fromResMsg, setfromResMsg] = useState('');
  const [fromResError, setfromResError] = useState('');
  const [formData, setFormData] = useState({
    email: ''
  });

  useEffect(() => {
    document.body.classList.add('WhatsappInsta')
    return () => {
      document.body.classList.remove('WhatsappInsta')
    }
  }, [])
  return (
    <LayoutWithoutFooter title="Chaashni by Maansi &amp; Ketan" description="Abode of designer Lehengas, Gowns, Sarees, Indo Westerns and Western Dresses. SHIPPING WORLDWIDE." > {/* JSON.stringify(lauth, null,4) */}
      <div className="site-content new-home-design WhatsappInsta"> <HomeBanner />
        <div className="home-full hometext-wrap">
          <div className="container">
            <div className="hometext-tab">
              <div className="lotas-flare"><img src="images/about/flare-pink.png" alt="flare-pink" /></div>
              <h3 className="newfont-heading">Handcrafted . Luxurious . Exquisite . रोमांटिक</h3>
              <p>Chaashni, meaning 'Sugar Syrup' in Hindi, is a women's designer wear label<br /> dedicated to capturing the sweetness and richness of timeless elegance.</p>
              <p>We specialise in Couture and Pret garments, creating pieces<br />  that blend traditional craftsmanship with modern sophistication.</p>
              <p>Indulge in our collections and let us add a touch of elegance to your journey.</p>
              <div className="lotas-box"><img src="images/about/Lotus-pink.png" alt="" /></div>
            </div>
          </div>
        </div>
      <VideoGalleryWA />  
        <CoutureWA />
        <CelebrityScroll />
        <AboutChaashniWA />
        <WomenOfChaashniWP />
        <InstagramWA />

        <div className="storenew-box"><StoreNewWA /></div>
        <div className="home-full homegroth-wrap">
          <div className="container">

          </div>
        </div>
      </div>
      <footer className="footer-area">
        <div className="container">
          <div>Copyright © {new Date().getFullYear()} Chaashni Couture. <span className='sitemap-link'></span></div>
        </div>
      </footer>
    </LayoutWithoutFooter>
  );
} 